import { AfterViewInit, Component, Input, OnChanges } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Constants } from '../../constants';
import { FormsUtils } from '../../../../utils/FormUtils';

declare var hbspt: any;

@Component({
  selector: 'app-form-company-template',
  templateUrl: './form-company-template.component.html',
  styleUrls: ['./form-company-template.component.scss']
})
export class FormCompanyTemplateComponent implements AfterViewInit {
  @Input() type: number;
  form: FormGroup;
  isAnual: boolean;
  isIntegration: boolean;
  isPlanmensual:boolean;
  isPlaanual:boolean;
  isPlanmensualEmpresas:boolean;
  idForm: string;

  constructor(
    private fb: FormBuilder,
    private _formsUtils: FormsUtils
  ) { }

  ngOnInit(): void {
    //Called after the constructor, initializing input properties, and the first call to ngOnChanges.
    //Add 'implements OnInit' to the class.
    this.idForm = this._formsUtils.getFormIdByLang();
    this._formsUtils.buildSovosForm();
  }

  ngAfterViewInit(): void {
    if (this.type) {
      this.isAnual = this.type === Constants.typeCompanyAnual ? true : false;
      this.isIntegration = this.type === Constants.typeCompanyIntegration ? true : false;
      this.isPlanmensual = this.type === Constants.planMensual ? true : false;
      this.isPlaanual = this.type === Constants.planAnual ? true : false;
      this.isPlanmensualEmpresas = this.type === Constants.planAnualEmpresas ? true : false;

      if (this.isAnual) {
          hbspt.forms.create({
            region: "na1",
            portalId: "5707307",
            formId: "17d7589a-dcd1-4b90-a7d4-a1f4f26a04da",
            target: '#form-company-container'
        });
      } else if (this.isPlanmensual) {
        hbspt.forms.create({
          region: "na1",
          portalId: "5707307",
          formId: "e93521eb-4f6d-406e-8870-1579db0ab59c",
          target: '#form-company-container'
        });
      } 
      else if (this.isPlanmensualEmpresas) {
        hbspt.forms.create({
          region: "na1",
          portalId: "5707307",
          formId: "d77fe450-3791-47c2-8ad4-804c95579cdc",
          target: '#form-company-container'
        });
      }
      else if (this.isPlaanual) {
        hbspt.forms.create({
          region: "na1",
          portalId: "5707307",
          formId: "d09b555c-e2ba-4315-b4da-279f5cef7f67",
          target: '#form-company-container'
        });
      }
       else if (this.isIntegration) {
        hbspt.forms.create({
          region: "na1",
          portalId: "5707307",
          formId: "c36a5e92-ff57-40f4-9fc4-a2a109abc631",
          target: '#form-company-container'
        });
      } else {
          hbspt.forms.create({
          portalId: '5707307',
          formId: '66537e48-72f0-4b53-8b21-1c0646fbfd8e',
          target: '#form-company-container'
        });
      }
    }
  }

  initForm(): void {
    switch (this.type) {
      case Constants.typeCompanyMonth:
        this.form = this.fb.group({
          name: ['', Validators.compose([Validators.required])],
          lastName: ['', Validators.compose([Validators.required])],
          email: ['', Validators.compose([Validators.required])],
          phone: ['', Validators.compose([Validators.required])],
          company: ['', Validators.compose([Validators.required])],
          sector: ['', Validators.compose([Validators.required])],
          transactionsPerComplement: ['', Validators.compose([Validators.required])],
          video: [false, Validators.compose([Validators.required])],
          sms: [false, Validators.compose([Validators.required])],
          usaConstancy: [false, Validators.compose([Validators.required])],
          etheriumConstancy: [false, Validators.compose([Validators.required])],
          mexicoConstancy: [false, Validators.compose([Validators.required])],
          ineValidation: [false, Validators.compose([Validators.required])],
          inePhoto: [false, Validators.compose([Validators.required])],
          signComparison: [false, Validators.compose([Validators.required])],
          videoConstancy: [false, Validators.compose([Validators.required])],
          videoSignConstancy: [false, Validators.compose([Validators.required])],
        });
        break;
      case Constants.typeCompanyAnual:
        this.form = this.fb.group({
          name: ['', Validators.compose([Validators.required])],
          lastName: ['', Validators.compose([Validators.required])],
          email: ['', Validators.compose([Validators.required])],
          phone: ['', Validators.compose([Validators.required])],
          company: ['', Validators.compose([Validators.required])],
          sector: ['', Validators.compose([Validators.required])],
          transactionsPerComplement: ['', Validators.compose([Validators.required])],
          video: [false, Validators.compose([Validators.required])],
          sms: [false, Validators.compose([Validators.required])],
          usaConstancy: [false, Validators.compose([Validators.required])],
          etheriumConstancy: [false, Validators.compose([Validators.required])],
          mexicoConstancy: [false, Validators.compose([Validators.required])],
          ineValidation: [false, Validators.compose([Validators.required])],
          inePhoto: [false, Validators.compose([Validators.required])],
          signComparison: [false, Validators.compose([Validators.required])],
          videoConstancy: [false, Validators.compose([Validators.required])],
          videoSignConstancy: [false, Validators.compose([Validators.required])],
        });
        break;
      case Constants.typeCompanyIntegration:
        this.form = this.fb.group({
          name: ['', Validators.compose([Validators.required])],
          lastName: ['', Validators.compose([Validators.required])],
          email: ['', Validators.compose([Validators.required])],
          phone: ['', Validators.compose([Validators.required])],
          company: ['', Validators.compose([Validators.required])],
          sector: ['', Validators.compose([Validators.required])]
        });
        break;
    }
  }

}
